import { render, staticRenderFns } from "./FirstAccessDetails.vue?vue&type=template&id=664e15ce&scoped=true&"
import script from "./FirstAccessDetails.vue?vue&type=script&lang=ts&"
export * from "./FirstAccessDetails.vue?vue&type=script&lang=ts&"
import style0 from "./FirstAccessDetails.vue?vue&type=style&index=0&id=664e15ce&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664e15ce",
  null
  
)

export default component.exports